import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Prodavnica.scss";
import { getProducts, getCategories } from "../../shop/api/products";
import AdManagerSlot from "../../components/AdvModule/AdManagerSlot";
import { useGlobalLocation } from "../../shared/LocationContext";

const formatPrice = (num) =>
  Number(num).toLocaleString("sr-RS") + " RSD";

export default function Prodavnica() {
  const { location } = useGlobalLocation();
  const [activeKat, setActiveKat] = useState("sve");
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([getProducts(), getCategories()])
      .then(([prods, cats]) => {
        setProducts(prods);
        setCategories(cats);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const filtrirane =
    activeKat === "sve"
      ? products
      : products.filter((p) => p.categories?.slug === activeKat);

  return (
    <div className="prodavnica">

      <div className="prodavnica__header">
        <div className="prodavnica__header-inner">
          <div className="prodavnica__header-ornament">✦ ✝ ✦</div>
          <h1 className="prodavnica__title">Prodavnica ikona</h1>
          <p className="prodavnica__sub">
            Ručno oslikane pravoslavne ikone pisane u vizantijskoj tradiciji
          </p>
        </div>
      </div>

      <div className="prodavnica__tabs">
        <button
          className={`prodavnica__tab ${activeKat === "sve" ? "active" : ""}`}
          onClick={() => setActiveKat("sve")}
        >
          Sve ikone
        </button>
        {categories.map((k) => (
          <button
            key={k.id}
            className={`prodavnica__tab ${activeKat === k.slug ? "active" : ""}`}
            onClick={() => setActiveKat(k.slug)}
          >
            {k.name}
          </button>
        ))}
      </div>

      <div className="prodavnica__body">
        {loading ? (
          <div className="prodavnica__loading">Učitavanje...</div>
        ) : (
          <>
            <div className="prodavnica__count">
              {filtrirane.length} {filtrirane.length === 1 ? "ikona" : "ikona"}
            </div>

            <div className="prodavnica__grid">
              {filtrirane.map((ikona) => (
                <NavLink key={ikona.id} to={`/prodavnica/${ikona.slug}`} className={`prodavnica__card ${ikona.kolicina_na_stanju === 0 ? "prodavnica__card--nedostupno" : ""}`}>
                  <div className="prodavnica__card-img">
                    <img src={ikona.images?.[0]} alt={ikona.name} loading="lazy" />
                    <span className="prodavnica__card-badge">{ikona.attributes?.tehnika}</span>
                    {ikona.kolicina_na_stanju === 0 && (
                      <span className="prodavnica__card-sold">Nije dostupno</span>
                    )}
                  </div>
                  <div className="prodavnica__card-body">
                    <h3 className="prodavnica__card-title">{ikona.name}</h3>
                    <div className="prodavnica__card-meta">
                      <span>{ikona.attributes?.tehnika}</span>
                      <span>{ikona.attributes?.dimenzije}</span>
                    </div>
                    <div className="prodavnica__card-footer">
                      <span className="prodavnica__card-price">{formatPrice(ikona.price)}</span>
                      {ikona.kolicina_na_stanju > 0 && (
                        <span className="prodavnica__card-btn">Kupi</span>
                      )}
                    </div>
                  </div>
                </NavLink>
              ))}
            </div>

            {filtrirane.length === 0 && (
              <div className="prodavnica__empty">
                <p>Nema ikona u ovoj kategoriji.</p>
                <button onClick={() => setActiveKat("sve")} className="prodavnica__tab active">
                  Prikaži sve
                </button>
              </div>
            )}
          </>
        )}

        <div className="banner-wrapper">
          <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1724367417806-0"} />
        </div>
      </div>
    </div>
  );
}
